<template>
    <div>
        <v-menu offset-y left>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                        small
                        color="primary"
                        depressed
                        dark
                        class="mr-1"
                        v-bind="attrs"
                        v-on="on"
                >
                    {{ $t('common.actions') }}
                    <v-icon right>mdi-chevron-down</v-icon>
                </v-btn>
            </template>
            <v-list dense>
                <v-list-item
                        v-if="securityStore.authorities['SAVE_PAY_SLIP']"
                        @click="$router.push({name: 'pay_slips.generate'})"
                >
                    <v-list-item-icon>
                        <v-icon color="teal">mdi-cash-register</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ $t('pay_slip.init_pay') }}</v-list-item-title>
                </v-list-item>
                <v-list-item
                        v-if="securityStore.authorities['UPDATE_PAY_SLIP']"
                        :disabled="annex.fermer"
                        @click="$router.push({name: 'pay_slips.import', params: {annexId: annex.id}})"
                >
                    <v-list-item-icon>
                        <v-icon color="blue darken-2">mdi-database-import</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ $t('pay_slip.import') }}</v-list-item-title>
                </v-list-item>
                <v-list-item
                        v-if="securityStore.authorities['UPDATE_PAY_SLIP']"
                        :disabled="annex.fermer"
                        @click="$router.push({name: 'pay_slips.annex.close', params: {id: annex.id}})"
                >
                    <v-list-item-icon>
                        <v-icon color="grey darken-2">mdi-lock</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ $t('common.lock') }}</v-list-item-title>
                </v-list-item>
                <v-divider/>
                <v-list-item
                    v-if="securityStore.authorities['UPDATE_PAY_SLIP']"
                    :disabled="annex.fermer"
                    @click="$router.push({name: 'pay_slips.add_pay_sections',params: {annexId: annex.id}})"
                >
                    <v-list-item-icon>
                        <v-icon color="teal">mdi-bookshelf</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title> {{ $t('common.add_pay_sections') }}</v-list-item-title>
                </v-list-item>
                <v-list-item
                    v-if="securityStore.authorities['UPDATE_PAY_SLIP']"
                    :disabled="annex.fermer"
                    @click="$router.push({name: 'pay_slips.delete_pay_sections', params: {annexId: annex.id}})"
                >
                    <v-list-item-icon>
                        <v-icon color="red">mdi-trash-can</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ $t('common.delete_pay_sections') }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
import {useSecurityStore} from "@/stores/Security";

export default {
    props: {
        annex: Object,
    },
    setup() {
        const securityStore = useSecurityStore();

        return {
            securityStore
        }
    }
};
</script>